import {api} from 'api/setup';

import {IBaseParamsRequest} from '../../../types';
import {
  IMetroAddFavoriteProduct,
  IMetroAddFavoriteProductIdsResponse,
  IMetroAddFavoriteProductRequest,
  IMetroAddFavoriteProductResponse,
  IMetroCategories,
  IMetroProductDetailsResponse,
  IMetroProductsRequest,
  IMetroProductsResponse,
  IMetroSearchResponse,
} from '../types';
import {IMetroFiltersResponse} from '../types/filters';

export const getMetroMainCategories = (): Promise<IMetroCategories> => {
  return api.get(`/market-categories/metro`);
};

export const getMetroProducts = ({
  slug,
  offset,
  limit,
  filters,
}: IMetroProductsRequest & {filters?: Record<string, any>}): Promise<IMetroProductsResponse> => {
  return api.get(`/market-category/${slug}`, {
    params: {offset, limit, ...filters},
  });
};

export const getMetroSearch = (query: string): Promise<IMetroSearchResponse> => {
  return api.get(`/markets/market-product-search`, {
    params: {query},
  });
};

export const getMetroSearchPage = ({
  slug,
  offset,
  limit,
  filters,
}: IMetroProductsRequest & {filters?: Record<string, any>}): Promise<IMetroProductsResponse> => {
  return api.get(`/market-category/search`, {
    params: {slug, offset, limit, ...filters},
  });
};

export const getMetroFilters = (slug: string): Promise<IMetroFiltersResponse> => {
  return api.get(`/market-category/${slug}/filters`);
};

export const getMetroSearchFilters = (query: string): Promise<IMetroFiltersResponse> => {
  return api.get(`/market-category/search/filters`, {
    params: {query},
  });
};

export const getMetroPromoFilters = (): Promise<IMetroFiltersResponse> => {
  return api.get(`/market-category/promo/filters`);
};

export const getMetroProductDetails = (slug: string): Promise<IMetroProductDetailsResponse> => {
  return api.get(`/market-product/${slug}`);
};

export const getMetroPromo = ({
  offset,
  limit,
  filters,
}: IBaseParamsRequest & {filters?: Record<string, any>}): Promise<IMetroProductsResponse> => {
  return api.get(`/market-category/promo`, {
    params: {offset, limit, ...filters},
  });
};

export const validateMetroProductsStock = (
  productIds: number[],
): Promise<{
  products: Array<{
    id: number;
    in_stock: boolean;
  }>;
}> => {
  return api.post('/market-product/check-stock', {
    product_ids: productIds,
  });
};

export const getMetroFavoriteProduct = (): Promise<IMetroAddFavoriteProduct[]> => {
  return api.get(`/favorite-product`);
};

export const getMetroFavoriteProductIds = (): Promise<IMetroAddFavoriteProductIdsResponse> => {
  return api.get(`/favorite-product/ids`);
};

export const addMetroFavoriteProduct = (
  data: IMetroAddFavoriteProductRequest,
): Promise<IMetroAddFavoriteProductResponse> => {
  return api.post(`/favorite-product/add`, data);
};

export const deleteMetroFavoriteProduct = (
  data: IMetroAddFavoriteProductRequest,
): Promise<IMetroAddFavoriteProductResponse> => {
  return api.post(`/favorite-product/delete`, data);
};
